export default __webpack_public_path__ + "static/media/Xclose.6c9a5366.svg";